export default __webpack_public_path__ + "static/media/animal-33.bf71ffc1.svg";